import { wqkgx } from '../config/keys';
import CryptoJS from 'crypto-js';

export const encryptData = (data: any) => {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), wqkgx).toString();
  return { data: encryptedData };
};

export const encryptEntrepreneurData = (data: any) => {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), wqkgx).toString();

  return encryptedData;
};
